export default __webpack_public_path__ + "static/media/bg_et.e43549d2.png";